import gql from 'graphql-tag'

export const GET_BANNERS = gql`

query (
  $type: String!,
  $page: Int!,
  $perPage: Int!, 
  $search: String!
) {
  getBanner(type: $type,
    page: $page,
    perPage: $perPage,
    search: $search) {
    banners {
      _id
      image
      name
      url
      onlineDate
      closeDate
      status
      isClick
      bannerTypes
    }
    totals
  }
}

`